import { BackButton } from "components/parts/BackButton";
import { Typography } from "components/parts/Typography/Typography";
import { usePageHeader } from "hooks/usePageHeader";
import { PageLevel, useConsoleState } from "providers/ConsoleStateProvider";
import React from "react";

import { useInterviewListWithNotificationEvents, useMonitors } from "./hook";
import {
  StyledContentWrapper,
  StyledHeadline,
  StyledInterviewDetailContainer,
  StyledInterviewListContainer,
  StyledInterviewManagementContainer,
  StyledPageNameContainer,
} from "./styled";
import { NotificationEvent } from "types/graphqlapi";
import { NotificationEventList } from "pages/MailHistoryManagement/NotificationEventList";
import { MailDetail } from "pages/MailHistoryManagement/MailDetail";

export type InterviewManagementParams = {
  subject_id: string;
};

export const MailHistoryManagement: React.FC = () => {
  const { selectedSubjectId, setScreenName, setPageLevel } = useConsoleState();
  const { pageHeader } = usePageHeader(selectedSubjectId);

  const { displayInterviewList } =
    useInterviewListWithNotificationEvents(selectedSubjectId);

  const [selectedNotificationEvent, setSelectedNotificationEvent] =
    React.useState<NotificationEvent>();

  const { monitorList } = useMonitors(selectedSubjectId);

  React.useEffect(() => {
    setScreenName("メール履歴");
    setPageLevel(PageLevel.fileAndScenarioAndMonitor);
  }, []);

  const selectNotificationEvent = (
    notificationEvent: NotificationEvent | undefined
  ) => {
    setSelectedNotificationEvent(notificationEvent);
  };

  return (
    <>
      <BackButton />
      <StyledInterviewManagementContainer>
        <StyledHeadline>
          <StyledPageNameContainer>
            <Typography
              weight={"bold"}
              size="xxlarge"
              text={`${pageHeader.subjectName}のメール履歴`}
            />
          </StyledPageNameContainer>
        </StyledHeadline>
        <StyledContentWrapper>
          <StyledInterviewListContainer>
            <NotificationEventList
              interviewList={displayInterviewList}
              selectedNotificationEvent={selectedNotificationEvent}
              selectNotificationEvent={selectNotificationEvent}
            />
          </StyledInterviewListContainer>
          <StyledInterviewDetailContainer>
            <MailDetail
              selectedNotificationEvent={selectedNotificationEvent}
              monitorList={monitorList}
            />
          </StyledInterviewDetailContainer>
        </StyledContentWrapper>
      </StyledInterviewManagementContainer>
    </>
  );
};
